import { toAbsoluteUrl } from "../../_helpers";

const config = window.layoutConfig;
config.loader.logo = toAbsoluteUrl(config.loader.logo);

export function getInitLayoutConfig() {
    return config;
}
